import { VisualTheme } from '@inwink/entities/visualtheme';

export const toPriceLabel: VisualTheme.IBindingConverterCallback = (val, properties, data, datacontext, i18n) => {
    const i18nHelper = datacontext?.i18nHelper || i18n;
    if (i18nHelper) {
        const trad = i18nHelper.translate('device.' + data?.currency?.toLowerCase() + '.format', null, '{0}');
        return trad.replace('{0}', `${data?.price || 0}`);
    }
    return val as any;
};